import React, { createContext, useState, useEffect } from "react";
import { toast } from "react-toastify";

export const DataContext = createContext();

const apiUrl = process.env.REACT_APP_URL;

export const DataProvider = ({ children }) => {
  const [employeeData, setEmployeeData] = useState([]);
  const [Token, setToken] = useState(localStorage.getItem("_ux98c_v1"));

  async function getEmp() {
    const url = `${apiUrl}/employee/employee`;

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === "success") {
        setEmployeeData(data.data);

        // console.log(data.data);
      } else {
        toast.error("Failed to fetch employee data");
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (Token) {
      getEmp();
    }
  }, [Token]);

  useEffect(() => {
    if (employeeData.id) {
      localStorage.setItem("id", employeeData.id);
    }
  }, [employeeData]);

  return (
    <DataContext.Provider value={{ employeeData, setToken }}>
      {children}
    </DataContext.Provider>
  );
};
